import React, { FC, ReactNode, useMemo } from 'react'
import { DiscoverButton } from '@components/DiscoverButton/DiscoverButton'
import { Grid, Stack, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

import ckbtc_image from '@assets/icons/ckbtc-image.png'
import cketh_image from '@assets/icons/cketh-image.png'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@utils/routes'
import { PLUG_DOCS_URL } from '@plug-core/constants/urls'
import LearnCard from '@components/LearnCard'
import { BTC_ID, ETH_ID } from '@plug-core/constants/tokenIds'

const LearnTab: FC = () => {
  const { t } = useTranslation()
  const { palette } = useTheme()

  const navigate = useNavigate()

  const openLink = (link: string) => {
    window.open(link, '_blank')
  }

  return (
    <Grid container spacing={1}>
      {/* <Grid item xs={12}>
        <DiscoverButton
          size="large"
          title={t('discover.tabs.home.banners.usdc.title')}
          description={t('discover.tabs.home.banners.usdc.description')}
          visual={ckusdc_image}
        />
      </Grid> */}
      <Grid item xs={6}>
        <LearnCard
          title={t('discover.tabs.learn.documentation.title')}
          category={t('discover.tabs.learn.documentation.category')}
          description={t('discover.tabs.learn.documentation.description')}
          emoji="👨‍💻"
          color={palette.rainbow.purple}
          onClick={() => openLink(PLUG_DOCS_URL)}
        />
      </Grid>
      <Grid item xs={6}>
        <LearnCard
          title={t('discover.tabs.learn.nfts.title')}
          category={t('discover.tabs.learn.nfts.category')}
          description={t('discover.tabs.learn.nfts.description')}
          emoji="🎨"
          color={palette.rainbow.blue}
          onClick={() => openLink('https://forms.gle/4LuS4UUUR36KEzL97')}
        />
      </Grid>
      <Grid item xs={6}>
        <Stack height="100%" spacing={1}>
          <DiscoverButton
            size="small"
            title={t('discover.tabs.home.banners.btc.title')}
            visual={ckbtc_image}
            onClick={() => navigate(ROUTES.MINT_CK(BTC_ID))}
          />
          <DiscoverButton
            size="small"
            title={t('discover.tabs.home.banners.eth.title')}
            visual={cketh_image}
            onClick={() => navigate(ROUTES.MINT_CK(ETH_ID))}
          />
        </Stack>
      </Grid>
      <Grid item xs={6}>
        <LearnCard
          title={t('discover.tabs.learn.grant.title')}
          category={t('discover.tabs.learn.grant.category')}
          description={t('discover.tabs.learn.grant.description')}
          emoji="🚀"
          color={palette.rainbow.green}
          onClick={() => openLink('https://forms.gle/4LuS4UUUR36KEzL97')}
        />
      </Grid>
    </Grid>
  )
}

export default LearnTab
